import listComponent from '@/util/proto/listComponent'

export default {
  extends: listComponent,
  data() {
    return {
      data: [],
      params: {},
      columns:[
        {
          type: 'index',
          width: 60,
          title: '序号',
          align: 'center'
        },
        {
          title: '所属网点',
          key: 'companyName',
          minWidth: 150,
        },
        {
          title: '用户',
          key: 'courierName',
          minWidth: 90,
        },
        {
          title: '开始时间',
          key: 'bindDatetimeText',
          minWidth: 160,
        },
        {
          title: '结束时间',
          key: 'releaseDatetimeText',
          minWidth: 160,
        },
        {
          title: '状态',
          key: 'stateText',
          minWidth: 100,
        }
      ],
      loading: false,
    }
  },
  props: ['carNo'],


  created() {
    this.$watch('carNo' , function(nv){
      if(nv){
        this.search()
      }else{
        this.data = []
      }
    },{immediate:true})
  },

  methods: {

    search() {
      let params = { search: this.carNo, pageSize: this.page.pageSize, pageNum: this.page.pageNum }

      this.loading = true
      this.$request.partnerCarLogs(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data ? resp.data.list : [], { 'bindDatetime': 'datetime', 'releaseDatetime': 'datetime', 'state': 'carUseState'})

          this.page.total = resp.data.total || 0
        }
      })
    }
  },

  render(){
    return <sl-table ref="table" loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} ></sl-table>
  }
}


